import React from "react";
import {useSelector} from "react-redux";
import styles from "./DesktopFiltersContainer.module.scss";
import MenuContainer from "../MenuContainer/MenuContainer";
import MainFacet from "../../components/MainFacet/MainFacet";
import getActiveMainFacetID from "../../Utils/getActiveMainFacetID";

const DesktopFiltersContainer = () => {
    const newFilterState = useSelector(state => state.newFilterReducer);
    const activeMainFacetID = getActiveMainFacetID(newFilterState);
    const showDesktopMenu = newFilterState.showDesktopMenu;
    const facets = newFilterState.facets;
    const newOrder = [
        'utdanninger',
        'laerested',
        'yrker',
        'artikler',
        'annet_innhold'
    ];

    let mainFacetsR = [];
    let errorMessage = null;

    newOrder.map(id => {
        if (facets[id]) {
            const item = facets[id];

            mainFacetsR.push(<MainFacet key={id} id={id} value={item.value} count={item.count}/>);
        }

        return true;
    });

    if (!mainFacetsR.length) {
        const errors = newFilterState.errors;

        if (errors.hovedfasett !== undefined) {
            errorMessage = <div className={styles.error}>Hovedfasett forespørsel feil</div>;
        }
    }

    return (
        <div className={styles.desktopfilterscontainer}>
            <div className={styles.mainfacets}>
                {mainFacetsR}
            </div>

            {errorMessage}

            {showDesktopMenu && activeMainFacetID !== "annet_innhold" &&
                <div className={styles.relative}>
                    <div tabIndex="0" id="filters+" className={styles.menucontainer}>
                        <MenuContainer/>
                    </div>
                </div>
            }
        </div>
    );

};

export default DesktopFiltersContainer;
